const login = '/login';
const logout = '/logout';

export const authEndpoints = { login, logout };
